export function required(name) {
  throw new Error(`Missing required argument: ${name}`);
}